import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Crisp } from 'crisp-sdk-web';
import { ZafronDashboard } from '../../components/dashboards/ZafronDashboard';

/**
 * Route-level wrapper. The API returns this URL as `urls.app` on every
 * dashboard record, so the path is part of the contract.
 *
 * Standalone by design: no app nav and no chat bubble, since both would sit
 * on top of a layout someone else designed. The list opens dashboards in
 * their own tab; the way back into the app is the mark in the controls.
 */
export default function DashboardView() {
  const { slug } = useParams();

  useEffect(() => {
    if (!process.env.REACT_APP_CHAT_KEY) return undefined;
    Crisp.chat.hide();
    return () => Crisp.chat.show();
  }, []);
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      <ZafronDashboard
        slug={slug}
        home={
          <Link
            to="/dashboards"
            aria-label="All dashboards"
            className="shrink-0 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-600"
          >
            <svg width="28" height="28" viewBox="0 0 40 40" fill="none" aria-hidden="true">
              <rect x="0" y="0" width="40" height="40" rx="9" ry="9" fill="#2563eb" />
              <text x="20" y="28" textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontWeight="300" fontSize="22" fill="#ffffff">Z</text>
            </svg>
          </Link>
        }
      />
    </div>
  );
}
